import {
  StyledInputLabel,
  StyledDatePicker,
  StyledInputWrapper,
  StyledFormItemField,
} from "./style";
import type { DatePickerFieldProps } from "./interfaces";

export const DatePickerField = (props: DatePickerFieldProps) => {

  return (
    <StyledInputWrapper>
      {props.label ? <StyledInputLabel>{props.label}</StyledInputLabel> : null}

      <StyledFormItemField name={props.name} rules={props.rules}>
        <StyledDatePicker
          format={ "DD/MM/YYYY"}
          placeholder={props.placeholder ? props.placeholder : ""}
          suffixIcon={null}
          allowClear={false}
          isEditable={props.isEditable}
          maxDate={props.maxDate}
        />
      </StyledFormItemField>
    </StyledInputWrapper>
  );
};
